import './ContactForm.css.proxy.js';
/* src/components/contact/ContactForm.svelte generated by Svelte v3.35.0 */
import {
	SvelteComponent,
	append,
	attr,
	children,
	claim_component,
	claim_element,
	claim_text,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	listen,
	mount_component,
	prevent_default,
	run_all,
	safe_not_equal,
	set_input_value,
	text,
	transition_in,
	transition_out
} from "../../web_modules/svelte/internal.js";

import { onMount } from "../../web_modules/svelte.js";
import { busy } from "../../_stores/app.js";
import Center from "../slot/Center.js";
import Button from "../button/Simple.js";

function create_if_block(ctx) {
	let div;
	let label;
	let t;
	let input;
	let input_value_value;

	return {
		c() {
			div = element("div");
			label = element("label");
			t = text("問い合わせ内容");
			input = element("input");
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { class: true });
			var div_nodes = children(div);
			label = claim_element(div_nodes, "LABEL", { for: true, class: true });
			var label_nodes = children(label);
			t = claim_text(label_nodes, "問い合わせ内容");
			label_nodes.forEach(detach);

			input = claim_element(div_nodes, "INPUT", {
				value: true,
				name: true,
				type: true,
				disabled: true,
				class: true
			});

			div_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(label, "for", "subject");
			attr(label, "class", "svelte-a2tusq");
			input.value = input_value_value = "" + (/*subject*/ ctx[0] + "についての問い合わせ");
			attr(input, "name", "subject");
			attr(input, "type", "text");
			input.disabled = true;
			attr(input, "class", "svelte-a2tusq");
			attr(div, "class", "line svelte-a2tusq");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, label);
			append(label, t);
			append(div, input);
		},
		p(ctx, dirty) {
			if (dirty & /*subject*/ 1 && input_value_value !== (input_value_value = "" + (/*subject*/ ctx[0] + "についての問い合わせ")) && input.value !== input_value_value) {
				input.value = input_value_value;
			}
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (39:894) <Center>
function create_default_slot(ctx) {
	let button;
	let t;

	return {
		c() {
			button = element("button");
			t = text("送信する");
			this.h();
		},
		l(nodes) {
			button = claim_element(nodes, "BUTTON", { type: true, class: true });
			var button_nodes = children(button);
			t = claim_text(button_nodes, "送信する");
			button_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(button, "type", "submit");
			attr(button, "class", "svelte-a2tusq");
		},
		m(target, anchor) {
			insert(target, button, anchor);
			append(button, t);
		},
		d(detaching) {
			if (detaching) detach(button);
		}
	};
}

function create_fragment(ctx) {
	let form;
	let div0;
	let label0;
	let t0;
	let input0;
	let div1;
	let label1;
	let t1;
	let input1;
	let div2;
	let label2;
	let t2;
	let input2;
	let div3;
	let label3;
	let t3;
	let textarea;
	let div4;
	let input3;
	let label4;
	let a;
	let t4;
	let span;
	let t5;
	let div5;
	let center;
	let current;
	let mounted;
	let dispose;
	let if_block = /*subject*/ ctx[0] && create_if_block(ctx);

	center = new Center({
			props: {
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			form = element("form");
			div0 = element("div");
			label0 = element("label");
			t0 = text("氏名");
			input0 = element("input");
			div1 = element("div");
			label1 = element("label");
			t1 = text("電話番号");
			input1 = element("input");
			div2 = element("div");
			label2 = element("label");
			t2 = text("Email");
			input2 = element("input");
			if (if_block) if_block.c();
			div3 = element("div");
			label3 = element("label");
			t3 = text("本文");
			textarea = element("textarea");
			div4 = element("div");
			input3 = element("input");
			label4 = element("label");
			a = element("a");
			t4 = text("個人情報保護方針");
			span = element("span");
			t5 = text("に同意する");
			div5 = element("div");
			create_component(center.$$.fragment);
			this.h();
		},
		l(nodes) {
			form = claim_element(nodes, "FORM", { name: true, method: true, class: true });
			var form_nodes = children(form);
			div0 = claim_element(form_nodes, "DIV", { class: true });
			var div0_nodes = children(div0);
			label0 = claim_element(div0_nodes, "LABEL", { for: true, class: true });
			var label0_nodes = children(label0);
			t0 = claim_text(label0_nodes, "氏名");
			label0_nodes.forEach(detach);

			input0 = claim_element(div0_nodes, "INPUT", {
				name: true,
				type: true,
				required: true,
				class: true
			});

			div0_nodes.forEach(detach);
			div1 = claim_element(form_nodes, "DIV", { class: true });
			var div1_nodes = children(div1);
			label1 = claim_element(div1_nodes, "LABEL", { for: true, class: true });
			var label1_nodes = children(label1);
			t1 = claim_text(label1_nodes, "電話番号");
			label1_nodes.forEach(detach);
			input1 = claim_element(div1_nodes, "INPUT", { name: true, type: true, class: true });
			div1_nodes.forEach(detach);
			div2 = claim_element(form_nodes, "DIV", { class: true });
			var div2_nodes = children(div2);
			label2 = claim_element(div2_nodes, "LABEL", { for: true, class: true });
			var label2_nodes = children(label2);
			t2 = claim_text(label2_nodes, "Email");
			label2_nodes.forEach(detach);

			input2 = claim_element(div2_nodes, "INPUT", {
				name: true,
				type: true,
				required: true,
				class: true
			});

			div2_nodes.forEach(detach);
			if (if_block) if_block.l(form_nodes);
			div3 = claim_element(form_nodes, "DIV", { class: true });
			var div3_nodes = children(div3);
			label3 = claim_element(div3_nodes, "LABEL", { for: true, class: true });
			var label3_nodes = children(label3);
			t3 = claim_text(label3_nodes, "本文");
			label3_nodes.forEach(detach);

			textarea = claim_element(div3_nodes, "TEXTAREA", {
				rows: true,
				name: true,
				required: true,
				class: true
			});

			children(textarea).forEach(detach);
			div3_nodes.forEach(detach);
			div4 = claim_element(form_nodes, "DIV", { class: true });
			var div4_nodes = children(div4);
			input3 = claim_element(div4_nodes, "INPUT", { type: true, class: true });
			label4 = claim_element(div4_nodes, "LABEL", { class: true });
			var label4_nodes = children(label4);
			a = claim_element(label4_nodes, "A", { href: true, target: true });
			var a_nodes = children(a);
			t4 = claim_text(a_nodes, "個人情報保護方針");
			a_nodes.forEach(detach);
			span = claim_element(label4_nodes, "SPAN", {});
			var span_nodes = children(span);
			t5 = claim_text(span_nodes, "に同意する");
			span_nodes.forEach(detach);
			label4_nodes.forEach(detach);
			div4_nodes.forEach(detach);
			div5 = claim_element(form_nodes, "DIV", { class: true });
			var div5_nodes = children(div5);
			claim_component(center.$$.fragment, div5_nodes);
			div5_nodes.forEach(detach);
			form_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(label0, "for", "name");
			attr(label0, "class", "svelte-a2tusq");
			attr(input0, "name", "name");
			attr(input0, "type", "text");
			input0.required = true;
			attr(input0, "class", "svelte-a2tusq");
			attr(div0, "class", "line required svelte-a2tusq");
			attr(label1, "for", "tel");
			attr(label1, "class", "svelte-a2tusq");
			attr(input1, "name", "tel");
			attr(input1, "type", "text");
			attr(input1, "class", "svelte-a2tusq");
			attr(div1, "class", "line svelte-a2tusq");
			attr(label2, "for", "email");
			attr(label2, "class", "svelte-a2tusq");
			attr(input2, "name", "email");
			attr(input2, "type", "email");
			input2.required = true;
			attr(input2, "class", "svelte-a2tusq");
			attr(div2, "class", "line required svelte-a2tusq");
			attr(label3, "for", "message");
			attr(label3, "class", "svelte-a2tusq");
			attr(textarea, "rows", "5");
			attr(textarea, "name", "message");
			textarea.required = true;
			attr(textarea, "class", "svelte-a2tusq");
			attr(div3, "class", "line required svelte-a2tusq");
			attr(input3, "type", "checkbox");
			attr(input3, "class", "svelte-a2tusq");
			attr(a, "href", "/privacy-policy");
			attr(a, "target", "_blank");
			attr(label4, "class", "expand svelte-a2tusq");
			attr(div4, "class", "line required force svelte-a2tusq");
			attr(div5, "class", "line svelte-a2tusq");
			attr(form, "name", "contact");
			attr(form, "method", "POST");
			attr(form, "class", "svelte-a2tusq");
		},
		m(target, anchor) {
			insert(target, form, anchor);
			append(form, div0);
			append(div0, label0);
			append(label0, t0);
			append(div0, input0);
			set_input_value(input0, /*name*/ ctx[1]);
			append(form, div1);
			append(div1, label1);
			append(label1, t1);
			append(div1, input1);
			set_input_value(input1, /*tel*/ ctx[2]);
			append(form, div2);
			append(div2, label2);
			append(label2, t2);
			append(div2, input2);
			set_input_value(input2, /*email*/ ctx[3]);
			if (if_block) if_block.m(form, null);
			append(form, div3);
			append(div3, label3);
			append(label3, t3);
			append(div3, textarea);
			set_input_value(textarea, /*message*/ ctx[4]);
			append(form, div4);
			append(div4, input3);
			append(div4, label4);
			append(label4, a);
			append(a, t4);
			append(label4, span);
			append(span, t5);
			append(form, div5);
			mount_component(center, div5, null);
			current = true;

			if (!mounted) {
				dispose = [
					listen(input0, "input", /*input0_input_handler*/ ctx[8]),
					listen(input1, "input", /*input1_input_handler*/ ctx[9]),
					listen(input2, "input", /*input2_input_handler*/ ctx[10]),
					listen(textarea, "input", /*textarea_input_handler*/ ctx[11]),
					listen(form, "submit", prevent_default(/*submit*/ ctx[5]))
				];

				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*name*/ 2 && input0.value !== /*name*/ ctx[1]) {
				set_input_value(input0, /*name*/ ctx[1]);
			}

			if (dirty & /*tel*/ 4 && input1.value !== /*tel*/ ctx[2]) {
				set_input_value(input1, /*tel*/ ctx[2]);
			}

			if (dirty & /*email*/ 8 && input2.value !== /*email*/ ctx[3]) {
				set_input_value(input2, /*email*/ ctx[3]);
			}

			if (/*subject*/ ctx[0]) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					if_block.m(form, div3);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}

			if (dirty & /*message*/ 16) {
				set_input_value(textarea, /*message*/ ctx[4]);
			}

			const center_changes = {};

			if (dirty & /*$$scope*/ 4096) {
				center_changes.$$scope = { dirty, ctx };
			}

			center.$set(center_changes);
		},
		i(local) {
			if (current) return;
			transition_in(center.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(center.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(form);
			if (if_block) if_block.d();
			destroy_component(center);
			mounted = false;
			run_all(dispose);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { endpoint } = $$props;
	let { subject } = $$props;
	let name = "";
	let tel = "";
	let email = "";
	let message = "";
	let formData;

	onMount(() => {
		$$invalidate(7, formData = new FormData());
	});

	async function submit() {
		busy.set(true);
		const res = await fetch(endpoint, { method: "POST", body: formData });

		if (res.ok) {
			busy.set(false);
			location.href = "/contact?thanks";
		} else {
			alert("正しく送信できませんでした。もう一度お試し頂くか、電話にてお問い合わせください。");
		}

		busy.set(false);
	}

	function input0_input_handler() {
		name = this.value;
		$$invalidate(1, name);
	}

	function input1_input_handler() {
		tel = this.value;
		$$invalidate(2, tel);
	}

	function input2_input_handler() {
		email = this.value;
		$$invalidate(3, email);
	}

	function textarea_input_handler() {
		message = this.value;
		$$invalidate(4, message);
	}

	$$self.$$set = $$props => {
		if ("endpoint" in $$props) $$invalidate(6, endpoint = $$props.endpoint);
		if ("subject" in $$props) $$invalidate(0, subject = $$props.subject);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*formData, name, tel, email, subject, message*/ 159) {
			$: if (formData) {
				formData.set("your-name", name);
				formData.set("your-tel", tel);
				formData.set("your-email", email);
				formData.set("your-subject", subject | "");
				formData.set("your-message", message);
			}
		}
	};

	return [
		subject,
		name,
		tel,
		email,
		message,
		submit,
		endpoint,
		formData,
		input0_input_handler,
		input1_input_handler,
		input2_input_handler,
		textarea_input_handler
	];
}

class ContactForm extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { endpoint: 6, subject: 0 });
	}
}

export default ContactForm;
//# sourceMappingURL=ContactForm.js.map
